export const IS_PROD = window.location.hostname === "privacy.samsung.com";
export const IS_PRE = window.location.hostname === "sdap.pre.samsungbdc.com";
export const IS_LOCALHOST = window.location.hostname === "localhost";
export const IS_STG = window.location.hostname === "sdap.stg.samsungbdc.com";
export const IS_DEV = window.location.hostname === "sdap.dev.samsungbdc.com";
